/**
 * Lazy accessors for build-time Google secrets. The previous module-load form
 * (`export const GOOGLE_API_KEY = ...`) coupled the entire `constants/API`
 * barrel to these env vars — a single missing variable crashed every
 * consumer of the barrel at module evaluation, including Storybook stories
 * that have nothing to do with maps. See QA-209.
 *
 * The throw now fires at the use site (a Maps component rendering), not at
 * import time, so unrelated code paths stay usable when these secrets are
 * absent (CI, local Storybook without `.env.local`, etc.).
 *
 * A provided secret always wins over the CI placeholder. GitHub Actions sets
 * CI=true in every job — including the dev/prod deploy builds that inject the
 * real REACT_APP_GOOGLE_* secrets — so keying the placeholder on ambient CI
 * alone shipped the literal string 'GOOGLE_API_KEY' to deployed bundles and
 * blanked every Maps-gated form (ISSUE-2395). The placeholder now only fills
 * in when the env var is absent (secret-less CI test runs).
 */

export const getGoogleApiKey = (): string => {
  const value = process.env.REACT_APP_GOOGLE_API_KEY || (process.env.CI === 'true' ? 'GOOGLE_API_KEY' : undefined)
  if (!value) throw new Error('GOOGLE_API_KEY env variable is missing')
  return value
}

export const getGoogleMapId = (): string => {
  const value = process.env.REACT_APP_GOOGLE_MAP_ID || (process.env.CI === 'true' ? 'GOOGLE_MAP_ID' : undefined)
  if (!value) throw new Error('GOOGLE_MAP_ID env variable is missing')
  return value
}
